import { ReactNode } from "react";
import { useOnVisibilityChange } from "../hooks/use-observe-visibility";
import * as css from "./style.css";

export type RowData = {
  value: ReactNode;
  align?: "left" | "center";
  sticky?: boolean;
  heading?: boolean;
};

export function Table<T>(props: {
  size?: "small" | "large";
  columns: {
    label: string;
    width?: string;
    sticky?: boolean;
    align?: "left" | "center";
    key: string;
    getRowData: (i: T) => RowData;
  }[];
  getItemDataKey: (i: T) => string;
  items: T[];

  /**
   * Must have stable identity!
   */
  onTableOverflow?: (isVisible: boolean) => void;
}) {
  const ref = useOnVisibilityChange<HTMLTableElement>({
    threshold: 1,
    onVisibilityChange: props.onTableOverflow,
  });

  return (
    <div className={css.container}>
      <table className={css.table({ size: props.size })} ref={ref}>
        <thead>
          <tr className={css.headerRow}>
            {props.columns.map((column) => {
              return (
                <th
                  key={column.key}
                  className={css.cell({
                    heading: true,
                    align: column.align,
                    sticky: column.sticky,
                  })}
                  style={{ width: column.width }}
                >
                  {column.label}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {props.items.map((i) => {
            return (
              <tr key={props.getItemDataKey(i)} className={css.row}>
                {props.columns.map((c) => {
                  const data = c.getRowData(i);

                  return (
                    <td
                      key={c.key}
                      className={css.cell({
                        align: data.align,
                        sticky: data.sticky,
                        heading: data.heading,
                      })}
                    >
                      {data.value}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
